import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from '@/features/auth/authContext';

/**
 * Access the current auth session and the sign-in/out actions.
 *
 * Must be called under `AuthProvider`. Throws rather than returning a soft null
 * so a missing provider is a loud failure in development instead of a silent
 * "always signed out" in production.
 */
export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return value;
}
